import { smoother } from './smooth-scroll.js'
import { mobile } from './check-res.js'

if (mobile) {
	const header = document.querySelector('.header')
	const hamburgerMenu = document.querySelector('.header__menu')
	const hamburgerBtn = document.querySelector('.header__hamburger')
	const hamburgerTrigger = document.querySelectorAll(
		'.header__hamburger, .header__menu-item'
	)

	hamburgerTrigger.forEach((btn) => {
		btn.addEventListener('click', () => {
			hamburgerBtn.classList.toggle('active')
			hamburgerMenu.classList.toggle('active')

			let hamburgerActive = btn.classList.contains('active')

			if (hamburgerActive) {
				hamburgerBtn.innerHTML = 'Close'
				smoother.paused(true)
				header.classList.add('active')
			} else {
				hamburgerBtn.innerHTML = 'Menu'
				smoother.paused(false)

				if (window.scrollY < header.offsetHeight) {
					header.classList.remove('active')
				}
			}
		})
	})
}
